import React, { Component } from 'react';
import { Button } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';
import { successToast, errorToast } from 'utils/toast';
import '../style.scss';

class ActivationButton extends Component {
    state = {
        clicked: false,
    };

    onClick = () => {
        const { provider, setActivation } = this.props;
        this.setState({ clicked: true });
        setActivation(
            provider.id,
            () => {
                successToast({
                    title: getLiteral('title_cardmanager_toast_activate'),
                    text: getLiteral('label_cardmanager_toast_activate'),
                });
            },
            () => {
                errorToast({ text: getLiteral('error_generalerror') });
                this.setState({ clicked: false });
            },
        );
    };

    render() {
        const { provider } = this.props;
        const { clicked } = this.state;
        let button;

        if (provider.active) {
            button = <Button isDisabled>{getLiteral('label_contact_us')}</Button>;
        } else if (clicked) {
            button = <Button isDisabled>{getLiteral('action_activate_provider')}</Button>;
        } else {
            button = (
                <Button onClick={this.onClick}>{getLiteral('action_activate_provider')}</Button>
            );
        }

        return <div className="activation-button">{button}</div>;
    }
}

export default ActivationButton;
